import script from "./Basketball.vue?vue&type=script&setup=true&lang=js"
export * from "./Basketball.vue?vue&type=script&setup=true&lang=js"

import "./Basketball.vue?vue&type=style&index=0&id=dd306ef4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd306ef4"]])

export default __exports__